import { render, staticRenderFns } from "./fields-array.vue?vue&type=template&id=697f0028&"
import script from "./fields-array.vue?vue&type=script&lang=js&"
export * from "./fields-array.vue?vue&type=script&lang=js&"
import style0 from "./fields-array.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {RzIconCross: require('/opt/cargo.front/node_modules/@razlet/ui/lib/modules/icons/icon-cross/index.js').default,RzAddArea: require('/opt/cargo.front/node_modules/@razlet/ui/lib/modules/components/add-area/index.js').default,BaseTooltip: require('/opt/cargo.front/src/components/base/tooltip.vue').default})
